module.exports = __webpack_public_path__ + "img/bird-dog_2x.7c3b2aa.png";


//////////////////
// WEBPACK FOOTER
// ./scripts/src/assets/raf/bird-dog_2x.png
// module id = 685
// module chunks = 0